import { useState, useEffect } from 'react';

export default function useToken() {
  const getToken = () => {
    const token = localStorage.getItem('token');

    if (!token || token === 'undefined' || token === 'null') {
      return null
    }
   // const userToken = tokenString;

    
    return token
  };

  const [token, setToken] = useState(getToken());

  const saveToken = userToken => {
    localStorage.setItem('token', userToken);
    setToken(userToken);
    window.dispatchEvent(new CustomEvent('sync_token', { detail: userToken }));
  };

  useEffect(() => {
    const handleLogin = (event) => {
      if (event.detail && event.detail.auth_token) {
        saveToken(event.detail.auth_token);
      }
    };
    const handleSync = (event) => {
      setToken(event.detail);
    };
    window.addEventListener('login', handleLogin);
    window.addEventListener('sync_token', handleSync);
    return () => {
      window.removeEventListener('login', handleLogin);
      window.removeEventListener('sync_token', handleSync);
    };
  }, []);
  return {
    setToken: saveToken,
    token
  }
}